/** Device-only question projection; excluded from the shared migration catalog and replica capture. */
export const localCardSchema = `CREATE TABLE IF NOT EXISTS "genericCards" (
  "qid" TEXT NOT NULL,
  "fractionalIndex" TEXT NOT NULL,
  "pageId" TEXT NOT NULL,
  "importance" REAL NOT NULL DEFAULT 1,
  "difficulty" REAL NOT NULL DEFAULT 1,
  "promptType" REAL NOT NULL DEFAULT 0,
  "stage" INTEGER NOT NULL DEFAULT 0,
  "repeatAt" INTEGER NOT NULL DEFAULT 'now',
  "ttaSeconds" INTEGER NOT NULL DEFAULT 30,
  "frozenAt" INTEGER,
  "deletedAt" INTEGER,
  "deletedBy" TEXT,
  "updatedAt" INTEGER NOT NULL,
  "touchedAt" INTEGER,
  "graduated" INTEGER NOT NULL DEFAULT 0,
  "cardKind" REAL,
  "node" TEXT,
  "acceptedRemoval" TEXT,
  PRIMARY KEY ("qid")
);

CREATE INDEX IF NOT EXISTS "idx_genericCards_pageId" ON "genericCards"("pageId");

-- Live frames are device-local. Receipt never mutates the replicated page.
CREATE TABLE IF NOT EXISTS pageLiveEdits (
  pageId TEXT NOT NULL,
  userId TEXT NOT NULL,
  direction TEXT NOT NULL CHECK(direction IN ('outgoing','incoming')),
  digest TEXT NOT NULL,
  epoch INTEGER NOT NULL,
  ranges TEXT NOT NULL,
  frame BLOB NOT NULL,
  PRIMARY KEY(pageId,userId,direction,digest)
);

-- Subscribe before the first receive; unregistered tables retain the full CDC feed.
CREATE TABLE IF NOT EXISTS _turso_replication_cdc_block_types(table_name TEXT NOT NULL,block_type TEXT NOT NULL,PRIMARY KEY(table_name,block_type));
INSERT OR IGNORE INTO _turso_replication_cdc_block_types VALUES('pages','question'),('pages','cloze'),('pages','rule');`
